import UserProfileClient from '../lib/apiClients/roofSnapApiClient/userProfileClient';
import QueryStringBuilder from '../lib/queryStringBuilder';
import { CALL_API } from '../middleware/api';
import { UserRoleId } from '../lib/roles';
import {
    GET_SKETCH_TECH_USER_PROFILES_REQUEST,
    GET_SKETCH_TECH_USER_PROFILES_SUCCESS,
    GET_SKETCH_TECH_USER_PROFILES_FAILURE,
} from './actionTypes';

export const getSketchTechUserProfiles = (page = 1, searchValue) => {
    const userProfileClient = new UserProfileClient('v1');
    const request = userProfileClient.getUserProfiles;

    const queryStringBuilder = new QueryStringBuilder();
    queryStringBuilder.setQueryParameter('page', page);
    if (searchValue) {
        queryStringBuilder.setQueryParameter('search', searchValue);
    }
    queryStringBuilder.setQueryParameter('userRoleIds', UserRoleId.SketchOsAdmin);
    queryStringBuilder.setQueryParameter('userRoleIds', UserRoleId.SketchTech);

    const queryParams =  queryStringBuilder.buildQueryString();

    return {
        [CALL_API]: {
            types: [
                GET_SKETCH_TECH_USER_PROFILES_REQUEST,
                GET_SKETCH_TECH_USER_PROFILES_SUCCESS,
                GET_SKETCH_TECH_USER_PROFILES_FAILURE,
            ],
            request,
            params: {
                queryParams,
            }
        }
    }
};
